// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Header_navBar__11kVp","headerButton":"Header_headerButton__kdHPZ","solveLogo":"Header_solveLogo__9WQg2"};